import { Fragment } from "react";
import { Link } from "react-router-dom";

function CpaAccepted({ filingItem }) {
  return (
    <Fragment>
      <h3 style={{ textAlign: "center" }}>Congrats</h3>
      <br></br>
      <hr></hr>
      <br></br>
      <div className="blueRect centered">
        <Link
          to={`/tax-filing/filing/${filingItem.filing_uuid}/`}
          className="btn btnBox btnWhite"
        >
          <b>Go to Filing</b>
        </Link>
        <Link to="/tax?status=pro" className="btn btnBox btnWhite">
          <b>All Filings</b>
        </Link>
      </div>
    </Fragment>
  );
}

export default CpaAccepted;
